import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { useIntl } from 'react-intl';
import ChartAnnotation from "chartjs-plugin-annotation";
import "./ChartsComponent.scss";
import moment from "moment";
import { Button } from "@material-ui/core";
import { ChartJsChartData, CurrentInternalDate } from "../../../interfaces";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import translate from "../../../i18n/translate";
import allActions from "../../../redux/actions";
import { useSelector, useDispatch } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getRandomNumber } from "../utils/sharedUtils";

const ChartsComponent = (props: any) => {
  let chartReference: any = {};
  const [cPeriod, setCPeriod] = useState<number>(); 
  const intl = useIntl();
  const [chartData, setChartData] = useState<ChartJsChartData | undefined>(undefined);
  const [isChartLoading, setIsChartLoading] = useState(true);
  const allInfo = useSelector((state: any) => state);
  const dispatch = useDispatch();
  const todayFullDate: CurrentInternalDate = {
    date: `${new Date().getMonth() + 1}/${new Date().getDate()}/${new Date().getFullYear()}`,
  };

  useEffect(()=>{
    changeAxisTranslation()
  },[chartReference]);

  useEffect(() => {
    const chInited: any =  sessionStorage.getItem('chInited');
    if(!chInited){
      const cPeriod: number = parseInt(sessionStorage.getItem('iPeriod') || "5");
      const cDate: any = sessionStorage.getItem('iDate') || todayFullDate.date;
      changePeriod(cPeriod, cDate);    
      sessionStorage.setItem('chInited', "true");
    }    
  }, []);

  useEffect(()=>{
    if(!allInfo.activityReport.isFailed && !allInfo.activityReport.isLoading) {
          setIsChartLoading(false);
          afterActivityReportsAPI(allInfo.activityReport.data);
    } else if(allInfo.activityReport.isFailed) {
      setIsChartLoading(false);
      afterActivityReportsAPIErrorHandle();
    }
  },[allInfo.activityReport]);

  const changeAxisTranslation = ()=>{    
    if(chartReference && Object.keys(chartReference).length > 0){
      chartReference.props.options.scales.yAxes[0].scaleLabel.labelString = intl.formatMessage({ "id" : "progress_acitivity_Minutes" });
      chartReference.updater.enqueueForceUpdate(chartReference, ()=>{});
    }
  };

  const reformatAPIData = (apiData: string) => {
    let dataRawArr: any = [];
    const apiDataParsed = JSON.parse(apiData || "{}");
    Object.keys(apiDataParsed).forEach((key) => {
      if (apiDataParsed[key]["Name"]) {
        dataRawArr.push(apiDataParsed[key]);
      }
    });
    return dataRawArr;
  };

  const formatXAxisText = (individualColumnData: any, period: number) => {
    switch (period) {
      case 1:
        // Daily
        return moment(`${individualColumnData["StartDate"]}`).format("MMM DD YYYY");
      case 2:
        // Weekly
        return moment(`${individualColumnData["EndDate"]}`).format("MMM DD YYYY");
      case 4:
        // Monthly
        return moment(`${individualColumnData["EndDate"]}`).format("MMM DD YYYY");
      case 5:
        // Quarterly
        return `${individualColumnData["Name"]}  ${moment(individualColumnData["EndDate"]).format("YYYY")}`;
      case 6:
        // Yearly
        return moment(`${individualColumnData["EndDate"]}`).format("YYYY");
      default:
        return "";
    }
  };

  const convertToMinutes = (cTime: string) => {
    cTime = `${cTime}`;
    return cTime && cTime.indexOf(":") >= 0
      ? parseInt(cTime.split(":")[0]) * 60 + parseInt(cTime.split(":")[1]) * 1
      : 0;
  };

  const afterActivityReportsAPI = (resp: any)=> {
    let chartDataBefore: any = {
      labels: [],
      datasets: [],
    };
    let allSelfPlacedData: any = [];
    let allTrainerLedData: any = [];
    let iPeriod = parseInt(sessionStorage.getItem("iPeriod")||"5");
    if (resp) {
      const rawString: string = `${JSON.stringify(resp)}`;
      reformatAPIData(rawString).map((individualEntry: any) => {
        let name = ((individualEntry.Name.split(' ')[0]) === 'Quarter') ? intl.formatMessage({ "id" : "progress_activity_tabQuarter" }) : individualEntry.Name;
        individualEntry.Name = name + " " + individualEntry.Name.split(' ')[1];
        chartDataBefore.labels.push(formatXAxisText(individualEntry, iPeriod));
        const selfPlacedData = individualEntry["UserActivitySummaryDetails"]["TotalHoursinService"] || "00:00";
        const trainerLedData = individualEntry["UserActivitySummaryDetails"]["HoursinTrainerLed"] || "00:00";
        allSelfPlacedData.push(convertToMinutes(selfPlacedData) ? convertToMinutes(selfPlacedData) : 0);
        allTrainerLedData.push(convertToMinutes(trainerLedData) ? convertToMinutes(trainerLedData) : 0);
      });
      chartDataBefore.datasets = [
        {
          type: "bar",
          label: intl.formatMessage({ "id" : "progress_acitivity_legend_selfpaced" }),
          backgroundColor: "#42babd",
          data: allSelfPlacedData,
        },
        {
          type: "bar",
          label: intl.formatMessage({ "id" : "progress_acitivity_legend_trainerLed" }),
          backgroundColor: "#236869",
          data: allTrainerLedData,
        }
      ];
      setChartData(chartDataBefore);
    }
    setCPeriod(iPeriod);
  }

  const afterActivityReportsAPIErrorHandle = () => {
    let iPeriod = parseInt(sessionStorage.getItem("iPeriod")||"5");
    setCPeriod(iPeriod);
  }

  const formatDataForChart = async (period: number = 1, currentFullDate?: CurrentInternalDate) => {            
    if (!currentFullDate) currentFullDate = todayFullDate;
    sessionStorage.setItem("iPeriod", `${period.toString()}`);
    sessionStorage.setItem("iDate", `${currentFullDate.date.toString()}`);
    setIsChartLoading(true);
    dispatch(allActions.activityReportAction.getActivityReport(allInfo.common.leuId, allInfo.peopleInformation.data.getpeopleInformation.accountId,period,currentFullDate.date));  
  };

  const changePeriod = (period: number, fDate: any) => {
    formatDataForChart(period, {date:fDate});
  };

  const chartNextPrev = (isPrev: boolean = false) => {
    let fullDate: CurrentInternalDate;
    const iDate: any ={date: (sessionStorage.getItem("iDate") || todayFullDate.date)};
    const period = cPeriod;
    fullDate = iDate ? iDate : todayFullDate;
    let periodFormat: any;
    let periodLength: any;
    let modifiedFDate: string;
    switch (period) {
      case 1:
        periodFormat = "days";
        periodLength = 7;
        break;
      case 2:
        periodFormat = "months";
        periodLength = 1;
        break;
      case 4:
        periodFormat = "months";
        periodLength = 3;
        break;
      default:
        periodFormat = "years";
        periodLength = 1;
        break;
    }
    if (isPrev) {
      modifiedFDate = moment(fullDate.date).subtract(periodLength, periodFormat).format("MM/DD/YYYY");
    } else {
      modifiedFDate = moment(fullDate.date).add(periodLength, periodFormat).format("MM/DD/YYYY");
    }
    formatDataForChart(period, { date: modifiedFDate });
  }

  const chartOptions = {
    animation: {
      duration: 0,
    },
    tooltips: {
      displayColors: true,
      callbacks: {
        mode: "x",
      },
    },
    scales: {
      xAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            display: false,
          },
        },
      ],
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
          type: "linear",
          scaleLabel: {
            display: true,
            labelString: "Minutes",
          },
        },
      ],
    },
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
      position: "bottom",
    },
    // annotation: {
    //   annotations: [
    //     {
    //       drawTime: "afterDatasetsDraw",
    //       id: "hline",
    //       type: "line",
    //       mode: "horizontal",
    //       scaleID: "y-axis-0",
    //       value: 50,
    //       borderColor: "#89be44",
    //       borderWidth: 3,
    //       borderDashOffset: 5,
    //       borderDash: [20, 20],
    //       label: {
    //         backgroundColor: "#89be44",
    //         content: "",
    //         enabled: false,
    //       },
    //     },
    //   ],
    // },
  };

  const chartPeriodObj = [
    {
      periodId: 1,
      periodName: "progress_activity_tabDaily"
    },
    {
      periodId: 2,
      periodName: "progress_activity_tabWeekly"
    },
    {
      periodId: 4,
      periodName: "progress_activity_tabMonthly"
    },
    {
      periodId: 5,
      periodName: "progress_activity_tabQuarterly"
    },
    {
      periodId: 6,
      periodName: "progress_activity_tabYearly"
    }
  ]
  
  return (
    <div className="charts">
      { isChartLoading ? 
        <div className="charts-loader-container"><CircularProgress size={50} color="primary" /></div>
      :
        <React.Fragment>
          <div className="charts-tabs">
            {  
              chartPeriodObj.map((cpobj: any, index: number) => {
                const { periodId, periodName } = cpobj;
                return (<Button key={getRandomNumber(index)}
                          variant="contained" color={cPeriod === periodId ? "primary" : "default"}
                          disabled={isChartLoading}
                          className={cPeriod === periodId ? "charts-tabs-btn contained" : "charts-tabs-btn"}
                          onClick={() => {
                            changePeriod(periodId, (sessionStorage.getItem("iDate") || todayFullDate));
                          }}
                        >
                          {translate(`${periodName}`)}
                        </Button>)
              })
            }
          </div>
          { chartData ?        
              <div className="charts-bar">
                <div className="charts-bar-container">
                  <Bar ref={(reference) => chartReference = reference } data={chartData} plugins={[ChartAnnotation]} options={chartOptions} />
                </div>
                <div className="charts-bar-legends">
                  { chartData.datasets.map((cData: any, index: number) => {
                      return (
                          <div className="charts-bar-legends-container" key={getRandomNumber(index)}>
                            <div className="charts-bar-legends-label">{translate(cData.label || "")}</div>
                            <div
                              className="charts-bar-legends-bar"
                              style={{ borderColor: `${cData.backgroundColor || "#000"}` }}
                            ></div>
                          </div>
                      );
                    })
                  }
                </div>
              </div>          
          : 
            <div className="no-data-tab">{translate("progress_activityreport_nodata")}</div>
          }
          <div className="charts-nav-btns">
            <Button disabled={false} variant="contained" color="primary" className="charts-nav-btns_btn" onClick={(event) => {chartNextPrev(true)}} aria-label={`${intl.formatMessage({ "id" : "prev" })}`}>
              <ChevronLeftIcon />
            </Button>
            <Button disabled={false} variant="contained" color="primary" className="charts-nav-btns_btn" onClick={(event) => {chartNextPrev()}} aria-label={`${intl.formatMessage({ "id" : "button_next" })}`}>
              <ChevronRightIcon />
            </Button>
          </div>
        </React.Fragment>
      }
    </div>
  );
};

export default ChartsComponent;
